__turbopack_context__.v({
  "button": "detail-page-pwa-back-button-module-scss-module__s9-Bwq__button",
  "button__icon": "detail-page-pwa-back-button-module-scss-module__s9-Bwq__button__icon",
});
